// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductExistAlso{display:flex;flex-direction:column;position:relative;width:100%}@media(min-width:1100px){.ProductExistAlso{width:200px}}.ProductExistAlso span{font-size:11px;font-size:1.1rem;position:absolute;left:15px;top:10px;z-index:1}.ProductExistAlso select{border-radius:5px;padding:20px 74px 5px 15px;width:auto}", ""]);
// Exports
module.exports = exports;
